<template>
	<div>
		<b-modal
			id="clonetest-sb"
			v-model="showModal"
			centered
			no-close-on-esc
			no-close-on-backdrop
			hide-footer
			hide-header
		>
			<div
				class="d-flex justify-content-between align-items-center clone-modal-hd px-4 py-3"
			>
				<div class="clone-hdtxt">Clone Project</div>
				<div class="pointer">
					<img
						@click="$emit('close')"
						class="rotate-on-hover"
						src="../../assets/projects-icons/x-close.svg"
						alt=""
					/>
				</div>
			</div>
			<div class="px-4 py-3 mt-2">
				<span class="template-name ml-1">
					Project Name
				</span>
				<!-- <div class="clonetestname d-flex align-items-center">
        <span class="ml-1 caution-modal-text"> Current Test Name :</span>
        <span class="ml-1 caution-modal-text"> {{ modalValue.name }}</span>
      </div> -->
				<b-row>
					<b-col>
						<div class="clone-InputField mt-2 mb-2">
							<b-form-input
								id="input-1"
								placeholder="Enter here"
								v-on:keyup.enter="cloneTest()"
								v-model="clonedata"
								type="text"
								:class="{ error: $v.clonedata.$error }"
								autofocus
							/>
							<div
								style="position: absolute; top: 15px; right: 30px; z-index: 1000"
								v-if="$v.clonedata.$error"
								v-b-popover.hover.top.v-danger="{ content: 'Required' }"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
						</div>
					</b-col>
				</b-row>
				<div class="d-flex justify-content-end mt-5 mb-1">
					<div class="cancel-btn">
						<b-button class="mr-3" @click="$emit('close')">
							Cancel
						</b-button>
					</div>
					<div class="new-addbtn-modal">
						<b-button @click="cloneTest()"> Clone </b-button>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>
<script>
import { required } from "vuelidate/lib/validators";

export default {
	props: {
		modalValue: Object,
	},
	data() {
		return {
			clonedata: null,
			showModal: true,
		};
	},
	validations: {
		clonedata: {
			required,
		},
	},
	methods: {
		cloneTest() {
			this.$v.$touch();
			if (!this.$v.$invalid)
				this.$emit("clone", {
					...this.modalValue,
					name: this.clonedata,
				});
		},
	},
};
</script>
<style>
.template-name {
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 14px;
	color: #344054;
}
.cancel-btn .btn-secondary {
	background-color: #fff;
	border-color: #72738e;
	border-radius: 40px;
	padding: 4px 13px 3px 13px;
	font-family: "Montserrat", sans-serif;
	font-weight: 600;
	font-size: 13px;
	color: #72738e;
	width: 85px;
	height: 31px;
}
.new-addbtn-modal .btn-secondary {
	background-color: var(--navy-blue);
	border-radius: 40px;
	border: 1px solid var(--navy-blue);
	font-family: var(--Montserrat);
	font-size: 13px;
	font-weight: var(--weight-M);
	color: #ffffff;
	padding: 4px 13px 3px 13px;
	width: 85px;
	height: 31px;
}
.clone-modal-hd {
	border-bottom: 1px solid #e4e7ec;
}
.clone-hdtxt {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 18px;
	color: #000000;
}
#clonetest-sb .modal-body {
	padding: 0rem;
}
@media (min-width: 576px) {
	#clonetest-sb .modal-dialog {
		max-width: 576px;
		margin: 1.75rem auto;
	}
}
.clone-InputField .form-control {
	box-sizing: border-box;
	padding: var(--size-10) var(--size-14);
	background: var(--color-white);
	/* border: 1px solid #d0d5dd !important; */
	box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
	border-radius: 8px;
	font-family: var(--Montserrat);
	font-weight: var(--weight-LM);
	font-size: var(--size-14);
	color: var(--subheading-color);
	height: 100%;
}

.clone-InputField:disabled {
	box-sizing: border-box;
	padding: var(--size-10) var(--size-14);
	background: #f7f7f7;
	box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
	border-radius: 8px;
	font-family: var(--Montserrat);
	font-weight: var(--weight-LM);
	font-size: var(--size-14);
	color: var(--subheading-color);
	height: 100%;
	border: none;
}
.clone-InputField::placeholder {
	font-family: "Montserrat", sans-serif;
	font-weight: 400;
	font-size: 14px;
	color: #667085;
}
#clonetest-sb .modal-dialog {
	width: 560px;
	height: 260px;
}
</style>
